/**
 * Will call the callback function with the user details when user details are
 * loaded by the personalization.js.
 * @param {function(Object)} callback
 */
export const onUserDetails = (callback) => {
  window.addEventListener("userDetails", event => {
    if (event && event.detail) {
      callback(event.detail)
    } else {
      callback({})
    }
  })
}
